export default function getFcmToken() {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ data: "getToken" }));
  }
}
